import React from "react";
import { useLoginUserMutation } from "../../redux/services/auth/loginAPI";
import { useFormik } from "formik";
import queryString from 'query-string';
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';

export default function Login({ handleUserChange }) {
  const [loginUser] = useLoginUserMutation();
  const navigate = useNavigate();

  const form = useFormik({
    initialValues: { mobile_number: "", password: "" },
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const response = await loginUser(queryString.stringify({
        mobile_number: values.mobile_number,
        password: values.password,
      }));

      if (response.data) {
        const user = response.data.user;
        if (user) {
          localStorage.setItem('user', JSON.stringify(user));
          localStorage.setItem("mobile_number", values.mobile_number);
          localStorage.setItem("loginCheck", true);
          handleUserChange?.(user);
        }

        Swal.fire({ icon: 'success', title: response.data.message, timer: 1600, showConfirmButton: false, toast: true, position: 'top-end', customClass: { popup: 'sweetalert2-toast-custom' } });
        navigate('/');
      } else {
        Swal.fire({ icon: 'warning', title: response.error?.data?.message || 'Login failed.', confirmButtonText: 'OK', customClass: { popup: 'sweetalert2-custom-popup' } });
      }

      resetForm();
      setTimeout(() => setSubmitting(false), 300);
    },
    validate: (values) => {
      const errors = {};
      if (!values.mobile_number) errors.mobile_number = 'Mobile number is required';
      if (!values.password) errors.password = 'Password is required';
      return errors;
    }
  });

  const fieldClass = (name) => `field ${form.errors[name] && form.touched[name] ? 'border-red-300 ring-4 ring-red-50' : ''}`;

  return (
    <section className="bg-surface py-12 sm:py-16">
      <div className="section-shell grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
        <div className="premium-card bg-slate-950 p-8 text-white">
          <span className="inline-flex rounded-full bg-white/10 px-3 py-1 text-xs font-black uppercase tracking-[0.2em]">Secure access</span>
          <h1 className="mt-6 text-4xl font-black tracking-tight sm:text-5xl">Welcome back to GoTrip.</h1>
          <p className="mt-5 text-lg leading-8 text-slate-300">Sign in to manage stays, dining orders, favorites, and personalized booking details.</p>
          <div className="mt-10 grid gap-4 sm:grid-cols-3">
            <div className="rounded-3xl bg-white/10 p-5"><p className="text-2xl font-black">Fast</p><p className="mt-2 text-sm text-slate-300">Checkout flow</p></div>
            <div className="rounded-3xl bg-white/10 p-5"><p className="text-2xl font-black">Saved</p><p className="mt-2 text-sm text-slate-300">Favorites</p></div>
            <div className="rounded-3xl bg-white/10 p-5"><p className="text-2xl font-black">Clear</p><p className="mt-2 text-sm text-slate-300">Booking history</p></div>
          </div>
        </div>

        <form onSubmit={form.handleSubmit} className="premium-card bg-white p-6 sm:p-8">
          <h2 className="text-2xl font-black tracking-tight text-ink">Login to your account</h2>
          <p className="mt-3 leading-7 text-muted">Use your mobile number and password to continue.</p>

          <div className="mt-7 space-y-5">
            <label>
              <span className="mb-2 block text-xs font-bold uppercase tracking-wide text-muted">Mobile number</span>
              <input className={fieldClass('mobile_number')} name="mobile_number" value={form.values.mobile_number} onChange={form.handleChange} onBlur={form.handleBlur} />
              {form.errors.mobile_number && form.touched.mobile_number && <p className="mt-2 text-sm font-bold text-red-500">{form.errors.mobile_number}</p>}
            </label>
            <label>
              <span className="mb-2 block text-xs font-bold uppercase tracking-wide text-muted">Password</span>
              <input className={fieldClass('password')} name="password" type="password" value={form.values.password} onChange={form.handleChange} onBlur={form.handleBlur} />
              {form.errors.password && form.touched.password && <p className="mt-2 text-sm font-bold text-red-500">{form.errors.password}</p>}
            </label>
          </div>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <Link to="/forget-password" className="text-sm font-bold text-gotrip-700 hover:text-gotrip-800">Forgot password?</Link>
            <button type="submit" disabled={form.isSubmitting} className="btn-primary w-full sm:w-auto">{form.isSubmitting ? 'Loading...' : 'Login'}</button>
          </div>

          <p className="mt-6 text-sm text-muted">
            Do not have an account? <Link to="/register" className="font-black text-gotrip-700 hover:text-gotrip-800">Register</Link>
          </p>
        </form>
      </div>
    </section>
  );
}
